import { render, staticRenderFns } from "./BankCredits.vue?vue&type=template&id=624a0e8e&scoped=true"
import script from "./BankCredits.vue?vue&type=script&lang=js"
export * from "./BankCredits.vue?vue&type=script&lang=js"
import style0 from "./BankCredits.vue?vue&type=style&index=0&id=624a0e8e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624a0e8e",
  null
  
)

export default component.exports